<ng-template cdkConnectedOverlay [cdkConnectedOverlayPositionStrategy]="globalOverlay" [cdkConnectedOverlayOpen]="true">
  <div class="digitalSignageContainer" [ngStyle]="getSignageBackgroundStyle()">
    <div class="dgMedia">
      @if (activeMedium() && activeMedium().type === 'video') {
        @if (videoFix) {
          <video
            loop
            muted
            autoplay
            #video
            (canplay)="video.play()"
            (loadedmetadata)="video.muted = true"
            [class.img-cover]="activeMedium().preferCover"
          >
            <source [src]="activeMedium().url" />
            It's not supported
          </video>
        }
      }

      @if (activeMedium() && activeMedium().type === 'image') {
        <img [class.img-cover]="activeMedium().preferCover" [src]="activeMedium().url" />
      } @else if (!config().media) {
        <!--          je to digitalSignage ale nema vybran v assistu DS template ma jen nastaven background (color nebo image) -->
        @if (config().backgroundId === backgroundTypeEnum.Image) {
          <img [class.img-cover]="true" [src]="config().backgroundImage" />
        }
      }
    </div>

    @if (canStopDigitalSignage()) {
      <div class="dgTouchMe">
        <div class="dgTouchMeIcon">
          <cue-icon [icon]="ICONS.cueCursorFinger" />
        </div>
        <span class="dgTouchMeTxt">{{ touchText() }}</span>
      </div>
    }
  </div>
</ng-template>
